import React from 'react';

const Duration = (props) => {
  const { duration: durationInSeconds } = props;

  const minutes = Math.floor(durationInSeconds / 60);
  const seconds = durationInSeconds % 60;

  const formattedMinutes = (minutes + '').padStart(2, '0');
  const formattedSeconds = (seconds + '').padStart(2, '0');

  return (
    <span className="duration">
      {formattedMinutes}:{formattedSeconds}
    </span>
  );
};

export default Duration;
